/**
 * Distance formatting helpers for FlowRide Frontend.
 * Formats meter-based distances into short human-readable labels.
 */

/**
 * Formats a distance in meters as a short display string.
 *
 * @param meters - Distance in meters.
 * @returns Formatted label (e.g. `"663 m"`, `"1.2 km"`), or `null` when the value is missing or invalid.
 */
export function formatDistanceMeters( meters: number | null | undefined ): string | null {
    if ( meters == null || !Number.isFinite( meters ) || meters < 0 ) {
        return null;
    }

    if ( meters >= 1000 ) {
        return `${ ( meters / 1000 ).toFixed( 1 ) } km`;
    }

    return `${ Math.round( meters ) } m`;
}
